export default __webpack_public_path__ + "static/media/logo-christmas.4658a6a4.png";